import { useEffect, useState } from "react";
import { getAxios } from "../utils/axios";
export const useInventoryDashboardData = () => {
    const [data, setData] = useState({
        items: [],
        media: [],
        storage: [],
        folderAliases: [],
        categories: [],
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchAll = async () => {
        setLoading(true);
        setError(null);
        try {
            const [i, m, s, f, c] = await Promise.all([
                getAxios().get("/inventory/items"),
                getAxios().get("/inventory/media"),
                getAxios().get("/inventory/storage"),
                getAxios().get("/inventory/folder_aliases"),
                getAxios().get("/inventory/categories"),
            ]);
            setData({
                items: i.data,
                media: m.data,
                storage: s.data,
                folderAliases: f.data,
                categories: c.data,
            });
        }
        catch (err) {
            console.error("Failed to load inventory dashboard data", err);
            setError(err.message);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchAll();
    }, []);
    return { ...data, loading, error, fetchAll };
};
